/**
 * Последний ответ медленной ручки — чтобы страница рисовалась сразу.
 *
 * Сервер в Токио, путь к нему местами теряет пакеты, и запрос, который на
 * сервере занимает миллисекунды, у человека висит 5–60 секунд. Всё это время
 * страница показывала «Загрузка…». Здесь храним прошлый ответ в sessionStorage
 * (живёт, пока открыта вкладка) и рисуем его сразу; свежий подменяет его, как
 * только придёт.
 *
 * Ключ — имя страницы плюс пользователь из токена: при входе под другим
 * пользователем в той же вкладке чужие данные не покажутся. Хранилище может
 * быть недоступно (приватное окно, запрет сайта) — тогда просто нет кеша.
 */

function userKey(): string {
  try {
    const tok = localStorage.getItem('access_token') || '';
    const part = tok.split('.')[1];
    if (!part) return 'anon';
    const json = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/')));
    return String(json.sub ?? json.username ?? 'anon');
  } catch {
    return 'anon';
  }
}

const fullKey = (name: string) => `sb_pc:${name}:${userKey()}`;

export function readPageCache<T>(name: string): T | null {
  try {
    const s = sessionStorage.getItem(fullKey(name));
    return s ? (JSON.parse(s) as T) : null;
  } catch {
    return null;
  }
}

export function writePageCache(name: string, data: unknown): void {
  try {
    sessionStorage.setItem(fullKey(name), JSON.stringify(data));
  } catch { /* переполнено или запрещено — живём без кеша */ }
}
